import {
  MoreTableCell,
  type MoreTableCellProps
} from "@/molecules/MoreTableCell"

export const CweCell = (value: MoreTableCellProps) => {
  if (!value?.items?.length) return value?.label || ""

  return MoreTableCell(value)
}
